import React, {useEffect, useState} from "react";
import enJson from './locales/en.json'
import jaJson from './locales/ja.json'
import i18n from 'i18next'
import {initReactI18next, TFunction, useTranslation} from "react-i18next";
import {
    AppBar,
    Button,
    makeStyles,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tabs,
    Toolbar,
    Typography
} from "@material-ui/core";
import Box from "@material-ui/core/Box";
import Table from '@material-ui/core/Table';
import Tab from '@material-ui/core/Tab';
import timeLib from './lib/time'
import {RouteComponentProps} from "react-router-dom";
import {collection, getDocs, getFirestore, orderBy, query, where} from "firebase/firestore";
import {getAuth} from "firebase/auth";

i18n.use(initReactI18next).init({
    resources: {
        en: {translation: enJson},
        ja: {translation: jaJson}
    },
    lng: 'ja',
    fallbackLng: 'ja',
    interpolation: {escapeValue: false}
}).then()

const TotalRanking: React.FC<RouteComponentProps> = (props: RouteComponentProps) => {
    const useStyles = makeStyles(() => ({
        container: {
            margin: '0 auto',
            padding: '20px',
            maxWidth: '500px'
        },
        tab: {
            minWidth: '50px'
        },
        headerTitle: {
            padding: '10px'
        }
    }))
    const classes = useStyles()

    const [t, i18n] = useTranslation()
    const [tabValue, setTabValue] = useState(0)
    const [subTabValue, setSubTabValue] = useState(0)
    const [rankingData, setRankingData] = useState<any[]>([])
    const [myRank, setMyRank] = useState(0)
    const gameTypeList = ["normal", "virtual", "withoutCube"]
    const moveCountList = [2, 3, 4, 5, 6, 7, 8]
    const db = getFirestore()

    useEffect(() => {
        if (localStorage.lang) {
            i18n.changeLanguage(localStorage.lang).then()
        } else {
            i18n.changeLanguage('ja').then()
        }
    }, [i18n])

    useEffect(() => {
        fetchResults(tabValue, subTabValue)
    }, [])

    const handleTabChanged = (event: React.ChangeEvent<{}>, newValue: number) => {
        fetchResults(newValue, subTabValue)
        setTabValue(newValue)
    }

    const handleSubTabChanged = (event: React.ChangeEvent<{}>, newValue: number) => {
        fetchResults(tabValue, newValue)
        setSubTabValue(newValue)
    }

    const fetchResults = (tabValue: number, subTabValue: number) => {
        getDocs(query(
            collection(db, "timeList"),
            where("gameType", "==", gameTypeList[tabValue]),
            where("moveCount", "==", moveCountList[subTabValue]),
            where("isTotalBestTime", "==", true),
            orderBy("time")
        )).then((data) => {
            const dataList: any[] = []
            let count = 1
            let myRankTmp = 0
            data.forEach((doc) => {
                if (count <= 10) {
                    dataList.push(doc.data())
                }
                if (doc.data().userId === getAuth().currentUser?.uid) {
                    myRankTmp = count
                }
                count++
            })
            setRankingData(dataList)
            setMyRank(myRankTmp)
        })
    }

    return (
        <div>
            <AppBar position={"relative"}>
                <Toolbar>
                    <Typography>{t('詰めキューブ')}</Typography>
                </Toolbar>
            </AppBar>
            <Box className={classes.container} maxWidth={"xs"} display={"flex"} flexDirection={"column"}>
                <Box display={"flex"}>
                    <Button variant='contained' onClick={() => props.history.push('/')}>
                        {t('戻る')}
                    </Button>
                </Box>
                <Box className={classes.headerTitle} display={"flex"} justifyContent={"center"}>
                    <Typography variant='h3'>{t('総合ランキング')}</Typography>
                </Box>
                <Box display={"flex"} justifyContent={"center"}>
                    <Tabs value={tabValue} onChange={handleTabChanged} centered>
                        <Tab className={classes.tab} label={t('通常')}/>
                        <Tab className={classes.tab} label={t('バーチャル')}/>
                        <Tab className={classes.tab} label={t('画像のみ')}/>
                    </Tabs>
                </Box>
                <Box display={"flex"} justifyContent={"center"}>
                    <div>
                        <Tabs value={subTabValue} onChange={handleSubTabChanged} centered>
                            <Tab className={classes.tab} label='2'/>
                            <Tab className={classes.tab} label='3'/>
                            <Tab className={classes.tab} label='4'/>
                            <Tab className={classes.tab} label='5'/>
                            <Tab className={classes.tab} label='6'/>
                            <Tab className={classes.tab} label='7'/>
                            <Tab className={classes.tab} label='8'/>
                        </Tabs>
                    </div>
                </Box>
                <Box display={"flex"} justifyContent={"center"}>
                    <div hidden={tabValue !== 0}>
                        <TabPanel value={subTabValue} index={0} storageData={rankingData} myRank={myRank} t={t}/>
                        <TabPanel value={subTabValue} index={1} storageData={rankingData} myRank={myRank} t={t}/>
                        <TabPanel value={subTabValue} index={2} storageData={rankingData} myRank={myRank} t={t}/>
                        <TabPanel value={subTabValue} index={3} storageData={rankingData} myRank={myRank} t={t}/>
                        <TabPanel value={subTabValue} index={4} storageData={rankingData} myRank={myRank} t={t}/>
                        <TabPanel value={subTabValue} index={5} storageData={rankingData} myRank={myRank} t={t}/>
                        <TabPanel value={subTabValue} index={6} storageData={rankingData} myRank={myRank} t={t}/>
                    </div>
                    <div hidden={tabValue !== 1}>
                        <TabPanel value={subTabValue} index={0} storageData={rankingData} myRank={myRank} t={t}/>
                        <TabPanel value={subTabValue} index={1} storageData={rankingData} myRank={myRank} t={t}/>
                        <TabPanel value={subTabValue} index={2} storageData={rankingData} myRank={myRank} t={t}/>
                        <TabPanel value={subTabValue} index={3} storageData={rankingData} myRank={myRank} t={t}/>
                        <TabPanel value={subTabValue} index={4} storageData={rankingData} myRank={myRank} t={t}/>
                        <TabPanel value={subTabValue} index={5} storageData={rankingData} myRank={myRank} t={t}/>
                        <TabPanel value={subTabValue} index={6} storageData={rankingData} myRank={myRank} t={t}/>
                    </div>
                    <div hidden={tabValue !== 2}>
                        <TabPanel value={subTabValue} index={0} storageData={rankingData} myRank={myRank} t={t}/>
                        <TabPanel value={subTabValue} index={1} storageData={rankingData} myRank={myRank} t={t}/>
                        <TabPanel value={subTabValue} index={2} storageData={rankingData} myRank={myRank} t={t}/>
                        <TabPanel value={subTabValue} index={3} storageData={rankingData} myRank={myRank} t={t}/>
                        <TabPanel value={subTabValue} index={4} storageData={rankingData} myRank={myRank} t={t}/>
                        <TabPanel value={subTabValue} index={5} storageData={rankingData} myRank={myRank} t={t}/>
                        <TabPanel value={subTabValue} index={6} storageData={rankingData} myRank={myRank} t={t}/>
                    </div>
                </Box>
            </Box>
        </div>
    )
}

interface TabPanelProps {
    value: number,
    index: number,
    storageData: Array<any>,
    myRank: number,
    t: TFunction<"translation">
}

const TabPanel = (props: TabPanelProps) => {
    const useStyles = makeStyles(() => ({
        table: {
            width: '300px'
        },
        myRank: {
            padding: '20px'
        }
    }))
    const classes = useStyles()

    return (
        <div hidden={props.value !== props.index}>
            <Box display={"flex"} justifyContent={"center"} className={classes.myRank}>
                {props.myRank !== 0 &&
                    <Typography variant={"h6"}>
                        {props.t('あなたの順位')}{props.myRank}{props.t('位')}
                    </Typography>
                }
            </Box>
            <TableContainer className={classes.table}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell align='center'>{props.t('ランク')}</TableCell>
                            <TableCell align='center'>{props.t('名前')}</TableCell>
                            <TableCell align='center'>{props.t('タイム(秒)')}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            props.storageData.map((item, index) =>
                                <TableRow key={index}>
                                    <TableCell align='center'>{index + 1}{props.t('位')}</TableCell>
                                    <TableCell align='center'>{item.name}</TableCell>
                                    <TableCell align='center'>{timeLib.format(item.time)}</TableCell>
                                </TableRow>
                            )
                        }
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    )
}

export default TotalRanking